import React from "react";
import { PropTypes } from "prop-types";
import { DragDropList } from "common/components";
import { observer } from "mobx-react";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { LoadioStoreHomeSection } from "administration/loadio/components";
import { MrbButton } from "mrb/components/button";
import { MrbContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { LoadioStoreSectionListLoader } from "administration/loadio/components";

function LoadioStoreHomeSectionListTemplate({ loadioStoreHomeSectionListViewStore, t }) {
    return (
        <MrbPage store={loadioStoreHomeSectionListViewStore} t={t}>
            <MrbPageHeader>
                <div>Loadio Store - Home Screen Sections</div>
                <Actions store={loadioStoreHomeSectionListViewStore} t={t} />
            </MrbPageHeader>

            <PanelHeader loadioStoreHomeSectionListViewStore={loadioStoreHomeSectionListViewStore} />

            <SectionList loadioStoreHomeSectionListViewStore={loadioStoreHomeSectionListViewStore} t={t} />
        </MrbPage>
    );
}

const SectionList = observer(function SectionList({ loadioStoreHomeSectionListViewStore, t }) {
    const { sections, reorderSections, loaderStore } = loadioStoreHomeSectionListViewStore;
    return (
        <div className="c-card--med c-card--primary u-mar--top--sml">
            <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <LoadioStoreSectionListLoader />}>
                {() => (
                    <React.Fragment>
                        {sections.length > 0 && (
                            <div>
                                <DragDropList
                                    droppableId="naki-store-home-sections"
                                    items={sections}
                                    onDragEnd={reorderSections}
                                    itemRender={(item) => (
                                        <LoadioStoreHomeSection
                                            id={item.id}
                                            loadioStoreHomeSectionListViewStore={loadioStoreHomeSectionListViewStore}
                                            t={t}
                                        />
                                    )}
                                ></DragDropList>
                            </div>
                        )}
                    </React.Fragment>
                )}
            </MrbContentLoader>
        </div>
    );
});

const Actions = observer(function Actions({ store, t }) {
    const { onClickSave, isSubmitting } = store;
    return (
        <React.Fragment>
            <MrbButton
                t={t}
                className="c-btn c-btn--base c-btn--primary"
                onClick={onClickSave}
                aria-label="Save"
                aria-busy={isSubmitting}
                label="Save"
                disabled={isSubmitting}
            />
        </React.Fragment>
    );
});

const PanelHeader = observer(function PanelHeader({ loadioStoreHomeSectionListViewStore }) {
    const { addSection, sections, isSubmitting, sectionsLimit, sectionsLimitReached } =
        loadioStoreHomeSectionListViewStore;
    const label = `Add Section (${sections.length}/${sectionsLimit})`;
    return (
        <div className="c-card--med c-card--primary">
            <MrbButton
                className="c-btn c-btn--med c-btn--ghost u-mar--right--sml"
                label={label}
                onClick={addSection}
                disabled={isSubmitting || sectionsLimitReached}
            />

            {sectionsLimitReached && (
                <div className="c-device-menu__note c-device-menu__note--secondary">
                    Maximum number of home screen sections reached.
                </div>
            )}
        </div>
    );
});

LoadioStoreHomeSectionListTemplate.propTypes = {
    loadioStoreHomeSectionListViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(LoadioStoreHomeSectionListTemplate);
